"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DurationTripField = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _rebrand = require("../../../icons-react/rebrand");
var _XMark = _interopRequireDefault(require("../../../icons-react/rebrand/XMark"));
var _styles = require("../styles");
var _search = require("../../../constants/search");
var _constants = require("../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DurationTripField = exports.DurationTripField = function DurationTripField(_ref) {
  var name = _ref.name,
    icon = _ref.icon,
    value = _ref.value,
    isMobile = _ref.isMobile,
    placeholder = _ref.placeholder,
    isWizard = _ref.isWizard,
    searchType = _ref.searchType,
    placeholderText = _ref.placeholderText,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    onClick = _ref.onClick,
    onClear = _ref.onClear,
    isActive = _ref.isActive,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$isWhiteLabel = _ref.isWhiteLabel,
    isWhiteLabel = _ref$isWhiteLabel === void 0 ? false : _ref$isWhiteLabel;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className,
    $isWizard: isWizard,
    $isActive: isActive,
    onClick: onClick
  }, isMobile && !isWizard && /*#__PURE__*/_react["default"].createElement(_styles.MobileLabel, {
    $isWhiteLabel: isWhiteLabel
  }, placeholder(searchType)), /*#__PURE__*/_react["default"].createElement(FakeInput, {
    id: name,
    $isMobile: isMobile,
    $isWizard: isWizard,
    $variant: variant
  }, searchType === _search.SEARCH_TYPE_NAMES.PACKAGE && (isWizard || !isMobile) && /*#__PURE__*/_react["default"].createElement(IconContainer, null, icon), value ? /*#__PURE__*/_react["default"].createElement(Value, {
    $isValue: true,
    $isMobile: isMobile
  }, value) : /*#__PURE__*/_react["default"].createElement(Value, {
    $isValue: false,
    $isMobile: isMobile
  }, placeholderText || placeholder(searchType)), !isMobile && value ? /*#__PURE__*/_react["default"].createElement(CrossContainer, {
    onClick: onClear
  }, /*#__PURE__*/_react["default"].createElement(CrossIcon, null)) : null, isMobile && !isWizard && /*#__PURE__*/_react["default"].createElement(StyledChevronDown, null)));
};
var StyledChevronDown = (0, _styledComponents["default"])(_rebrand.ChevronDown).withConfig({
  displayName: "DurationTripField__StyledChevronDown",
  componentId: "sc-15o5rb1-0"
})(["height:13px;path{fill:var(--grey2);}"]);
var CrossIcon = (0, _styledComponents["default"])(_XMark["default"]).withConfig({
  displayName: "DurationTripField__CrossIcon",
  componentId: "sc-15o5rb1-1"
})(["height:16px;path{fill:var(--grey2);}"]);
var CrossContainer = _styledComponents["default"].span.withConfig({
  displayName: "DurationTripField__CrossContainer",
  componentId: "sc-15o5rb1-2"
})(["margin-left:auto;height:15px;width:15px;"]);
var Container = _styledComponents["default"].div.withConfig({
  displayName: "DurationTripField__Container",
  componentId: "sc-15o5rb1-3"
})(["", " display:flex;flex-direction:column;gap:8px;position:relative;min-width:100px;font-weight:500;"], function (_ref2) {
  var $isWizard = _ref2.$isWizard;
  return !$isWizard && "width: 100%;";
});
var FakeInput = _styledComponents["default"].div.withConfig({
  displayName: "DurationTripField__FakeInput",
  componentId: "sc-15o5rb1-4"
})(["display:flex;position:relative;align-items:center;background-color:var(--white);", " padding:17px 8px;font-size:18px;line-height:22px;", " ", ""], function (_ref3) {
  var $variant = _ref3.$variant;
  return $variant === 'hotel' && (0, _styledComponents.css)(["background-color:var(--background);"]);
}, function (_ref4) {
  var $isMobile = _ref4.$isMobile,
    $isWizard = _ref4.$isWizard;
  return $isMobile ? (0, _styledComponents.css)(["", ";", " justify-content:space-between;"], _styles.mobileDefaultControlStyles, !$isWizard && "&:hover {\n            border: none;\n          }") : (0, _styledComponents.css)(["&:not(:first-child):before{content:'';width:1px;background-color:#fff;}&:not(:first-child):after{content:'';width:1px;height:40px;background-color:#e6e9ee;position:absolute;left:0;top:0;bottom:0;margin:auto;"]);
}, function (_ref5) {
  var $isWizard = _ref5.$isWizard;
  return $isWizard && (0, _styledComponents.css)(["background-color:transparent;width:auto;height:auto;padding:4px 8px;border:none;justify-content:initial;font-weight:normal;&[id=", "]{justify-content:end;}"], _constants.fieldParams.days[0].name);
});
var Value = _styledComponents["default"].span.withConfig({
  displayName: "DurationTripField__Value",
  componentId: "sc-15o5rb1-5"
})(["color:", ";border:none;cursor:inherit;white-space:pre;", ";"], function (_ref6) {
  var $isValue = _ref6.$isValue,
    $isMobile = _ref6.$isMobile;
  return $isValue || $isMobile ? 'inherit' : 'var(--grey2)';
}, function (_ref7) {
  var $isMobile = _ref7.$isMobile,
    $isValue = _ref7.$isValue;
  return ($isMobile || !$isValue) && (0, _styledComponents.css)(["font-weight:400"]);
});
var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "DurationTripField__IconContainer",
  componentId: "sc-15o5rb1-6"
})(["display:flex;justify-content:center;align-items:center;padding-right:4px;path{stroke:currentColor;}"]);